export function useScrollLock(lock: boolean): void {
  if (!document) {
    return;
  }
  if (lock) {
    document.documentElement.style.overflowY = 'hidden';
  } else {
    document.documentElement.style.overflowY = 'auto';
  }
}
